import { createAction, props } from '@ngrx/store';
import { RiskItem } from 'src/app/api/models/quotationRequest.model';

export const patchRoommate = createAction(
  '[Roommate Page] Patch Roommate info',
  props<{ payload: Partial<RiskItem[]> }>()
);

export const init = createAction('[Init]');
